import { SEO, breadcrumbSchema } from "../components/SEO";
import { Breadcrumbs } from "../components/Breadcrumbs";
import { GuideCard, UpcomingCard } from "../components/Cards";
import { CTASection } from "../components/CTASection";
import { Reveal } from "../components/Reveal";
import { PagePhoto } from "../components/PagePhoto";
import { pagePhotos } from "../content/photos";
import { useLp } from "../i18n/lang";
import { useCopy } from "../i18n/copy";
import { useGuides, useUpcomingGuides, useGuideCategories } from "../i18n/content";

export default function GuidesHub() {
  const c = useCopy("guidesHub");
  const cr = useCopy("crumbs");
  const lp = useLp();
  const guides = useGuides();
  const upcomingGuides = useUpcomingGuides();
  const guideCategories = useGuideCategories();
  const crumbs = [
    { name: cr.home, path: lp("/") },
    { name: cr.guides, path: lp("/guias/") },
  ];
  return (
    <>
      <SEO
        title={c.seoT}
        description={c.seoD}
        path="/guias/"
        jsonLd={[breadcrumbSchema(crumbs)]}
      />
      <Breadcrumbs items={crumbs} />
      <section className="container-site section-gap !pt-10" data-testid="guides-hub">
        <Reveal>
          <p className="tech-label mb-4">{c.kicker}</p>
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold leading-tight max-w-3xl">
            {c.h1}
          </h1>
          <p className="mt-5 max-w-2xl text-base sm:text-lg text-slate-600 leading-relaxed">
            {c.introA} {guideCategories.join(" · ").toLowerCase()}.
          </p>
        </Reveal>
        <PagePhoto photo={pagePhotos["_hub-guias"]} className="mt-12 max-w-4xl" />
        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {guides.map((g, i) => (
            <Reveal key={g.slug} delay={i * 0.05}><GuideCard guide={g} /></Reveal>
          ))}
        </div>
        <Reveal className="mt-16">
          <h2 className="text-xl sm:text-2xl font-semibold text-ink">{c.relatedH}</h2>
        </Reveal>
        <div className="mt-7 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {upcomingGuides.map((g) => (
            <UpcomingCard key={g.title} title={g.title} category={g.category} href={g.href} />
          ))}
        </div>
      </section>
      <CTASection title={c.ctaT} text={c.ctaX} />
    </>
  );
}
